import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';
import user from 'js/lib/user';

import { getDefaultEnrollableSessionId } from 'bundles/author-branches/utils/BranchUtils';

const viewAsLearnerInCourseAPI = API('/api/viewAsLearnerInCourse.v1', { type: 'rest' });

export const changeUserEnrollment = (
  actionContext: $TSFixMe,
  {
    courseId,
    sessionId,
    groupId,
    userCanSwitchGroups,
    selectDefaultSessionForBranch,
    findPublicSessionsIfPossible,
    newWindow,
    onCompleteChangeUserEnrollment = () => {},
    branch,

    // in some cases we only want to open a new window AFTER enrollment is done, so we can skip the reload. e.g. <CourseNavigationPreviewButtonV2 />
    skipReloadWindow = false,
  }: $TSFixMe
) => {
  const userId = user.get().id;
  const maybeReloadWindow = () => {
    if (skipReloadWindow) {
      onCompleteChangeUserEnrollment();
      return;
    }

    const windowToUse = newWindow || window;
    windowToUse.location.reload();
    onCompleteChangeUserEnrollment();
  };

  const newSessionId =
    selectDefaultSessionForBranch && branch
      ? getDefaultEnrollableSessionId(branch, findPublicSessionsIfPossible)
      : sessionId;
  const newGroupIds = userCanSwitchGroups && groupId ? [groupId] : [];
  const data = {
    userId,
    courseId,
    sessionId: newSessionId,
    groupIds: newGroupIds,
  };

  Q(viewAsLearnerInCourseAPI.post(new URI().addQueryParam('action', 'start').toString(), { data }))
    .then(maybeReloadWindow)
    .done();
};

export default { changeUserEnrollment };
